import React, { useState, useEffect } from "react";
import FadeLoader from "react-spinners/FadeLoader";
import { getSocketEmit, getValuesSocketData } from "helpers/secretManager";
import FormikForm from "components/shared/FormikForm_1";
import moment from "moment";
import { formatNumber } from "helpers/common";
import useSocket from "hooks/useSocket";
import { post } from "helpers/api_helper";
import { GET_STATISTICS_DATA, EXPORT_STATS } from "helpers/url_helper";
import { Card, CardBody, Col, Row } from "reactstrap";
import { CardHeader } from "react-bootstrap";
import { toast } from "react-toastify";

const InputFieldsForSearch = [
  {
    name: "datepicker",
    type: "datepicker",
    label: "",
    placeholder: "",
  },
];

const initialValuesForFilter = {
  startDate: moment().subtract(1, "days"),
  endDate: moment().subtract(1, "days"),
};
// console.info("Previous Day:", moment().subtract(1, "day").format("YYYY-MM-DD"));
// console.info("Previous Day:2", moment().subtract(1, "days").format("YYYY-MM-DD"));

const StatisticsWithFilter = () => {
  const { socket, socketConnect } = useSocket();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [dateFilter, setDateFilter] = useState({
    startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
    endDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  });
  const [filter, setFilter] = useState({
    startDate: null,
    endDate: null,
  });
  const [dataCounts, setDataCounts] = useState({
    min3Games: 0,
    min3Tasks: 0,
    dailyActiveUsers: 0,
    linkedBitanica: 0,
    newUsersCount: 0,
    todayBtnc: 0,
    gameRounds: 0,
    todayTaskBtnc: 0,
    todayReferralBtnc: 0,
    todayBtncConsumed: 0,
    todayCoins: [],
  });

  const handleFilterForm = (info) => {
    if (!dateFilter.startDate || !dateFilter.endDate) {
      return;
    }
    setFilter({
      ...filter,
      startDate: dateFilter.startDate,
      endDate: dateFilter.endDate,
    });
  };

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
    setDateFilter((prevFilter) => ({
      ...prevFilter,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }));
    setShowPicker(false);
  };

  useEffect(() => {
    if (socketConnect) {
      getApiData(filter);
    }
  }, [filter, socketConnect]);

  async function getApiData(queryData) {
    try {
      setLoading(true);
      const { signature, nonce } = await getValuesSocketData();
      const keys = [
        { key: "newUsersCount", stateKey: "newUsersCount" },
        { key: "dailyActiveUsers", stateKey: "dailyActiveUsers" },
        { key: "todayBtnc", stateKey: "todayBtnc" },
        { key: "gameRounds", stateKey: "gameRounds" },
        { key: "todayCoins", stateKey: "todayCoins" },
        { key: "min3Games", stateKey: "min3Games" },
        { key: "min3Tasks", stateKey: "min3Tasks" },
        { key: "linkedBitanica", stateKey: "linkedBitanica" },
        { key: "todayTaskBtnc", stateKey: "todayTaskBtnc" },
        { key: "todayReferralBtnc", stateKey: "todayReferralBtnc" },
        { key: "todayBtncConsumed", stateKey: "todayBtncConsumed" },
      ];

      const promises = keys.map(({ key }) => {
        const start = queryData?.startDate || dateFilter.startDate;
        const end = queryData?.endDate || dateFilter.endDate;
        const payload = { key };
        if (start) payload.startDate = start;
        if (end) payload.endDate = end;
        return post(
          GET_STATISTICS_DATA,
          payload,
          { signature, nonce }
        );
      });

      // Wait for all the promises to resolve
      const responses = await Promise.all(promises);

      // Update the state with the results
      const updatedDataCounts = keys.reduce((acc, { stateKey }, index) => {
        acc[stateKey] =
          typeof responses[index]?.data !== "string"
            ? responses[index]?.data
            : [];
        return acc;
      }, {});

      setDataCounts((prev) => ({ ...prev, ...updatedDataCounts }));
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  const exportData = async () => {
    try {
      setLoading(true);
      const { signature, nonce } = await getValuesSocketData();
      const start = filter.startDate || dateFilter.startDate;
      const end = filter.endDate || dateFilter.endDate;
      const payload = { key: "daily" };
      if (start) payload.startDate = start;
      if (end) payload.endDate = end;
      const res = await post(
        EXPORT_STATS,
        payload,
        { signature, nonce }
      );
      if (res?.status) {
        toast.success("File exported successfully!");
        if (res?.data) {
          window.open(res?.data, "_blank");
        }
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.error("error while generating export file", error);
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <div className="row justify-content-between">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <Row>
            <div className="card">
              <div className="row justify-content-between">
                <div className="col-12">
                  <div className="card-header d-flex justify-content-between">
                    <h5 className="section-title">Daily Statistics</h5>
                    <button
                      type="btn"
                      onClick={() => exportData()}
                      className=" float-right btn btn-primary mx-2 my-2"
                    >
                      Export
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <Col sm={12} lg={12}>
              <FormikForm
                initialValues={initialValuesForFilter}
                onSubmit={handleFilterForm}
                loading={loading}
                inputFields={InputFieldsForSearch}
                buttonText={"Search"}
                dateRange={dateFilter}
                showPicker={showPicker}
                setShowPicker={setShowPicker}
                handleSelect={handleSelect}
                col={4}
              />
            </Col>
            <Col sm={12} lg={12} className="my-2">
              <Row>
                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Completed 3 tasks</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.min3Tasks)}
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Played at Least 3 Games</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.min3Games)}
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Linked to Bitanica</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.linkedBitanica)}
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Daily Active</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.dailyActiveUsers)}
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>New Users Count</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.newUsersCount)}
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Game BTNC</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.todayBtnc)}
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Game Rounds</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.gameRounds)}
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Task BTNC</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.todayTaskBtnc)}
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Referral BTNC</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.todayReferralBtnc)}
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="3" md="4" sm="6" className="my-2">
                  <Card className="my-2">
                    <CardHeader>Consumed BTNC</CardHeader>
                    <CardBody className="spinner-content">
                      {formatNumber(dataCounts?.todayBtncConsumed)}
                    </CardBody>
                  </Card>
                </Col>

                {dataCounts?.todayCoins?.length ? (
                  <Col lg={12}>
                    <p>Today Coins</p>
                    <Row>
                      {dataCounts?.todayCoins?.map((coin, key) => (
                        <Col key={key} lg="3" md="4" sm="6" className="my-2">
                          <Card className="my-2">
                            <CardHeader className="text-uppercase">
                              {coin?._id}
                            </CardHeader>
                            <CardBody className="spinner-content">
                              {formatNumber(coin?.totalAmount)}
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                ) : null}
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default StatisticsWithFilter;
